import { createSelector } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { RootState } from '../../app/store';
import { LanguageState } from '../../domains/locales';

const selectLanguageDomain = (state: RootState) => state[SLICE_NAME];

export const selectLocale = createSelector(
  selectLanguageDomain,
  (state: LanguageState) => state.locale,
);

export const selectLanguage = createSelector(
  selectLanguageDomain,
  (state: LanguageState) => {
    return state.listLanguages.find((l) => l.code === state.locale);
  },
);
